import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BRAND } from '../brand';
import { LegalDocLayout } from '../components/LegalDocLayout';

const Terminos = () => {
  const navigate = useNavigate();
  const cityPlaceholder = BRAND.legalCity || '[CIUDAD DEL DOMICILIO LEGAL — PENDIENTE CLIENTE]';
  const wa = BRAND?.landing?.footerWhatsAppNumber;
  const waDisplay = BRAND?.landing?.footerWhatsAppDisplay || (wa ? `+${wa}` : null);

  const sections = [
    { title: 'Aceptación de los términos', body: (
      <p>Al registrarte y usar {BRAND.name} declaras haber leído, comprendido y aceptado íntegramente los presentes términos y condiciones. Si no estás de acuerdo, debes abstenerte de usar la plataforma.</p>
    )},
    { title: 'Quiénes prestan el servicio', body: (
      <p>{BRAND.name} es operado por <strong>{BRAND.legalName.toUpperCase()}</strong>, empresa formalizada en Chile, con domicilio comercial en {cityPlaceholder}. Nuestro objeto es facilitar transferencias internacionales de dinero entre Chile y los países habilitados por {BRAND.name}.</p>
    )},
    { title: 'Naturaleza del servicio', body: (
      <>
        <p>{BRAND.name} actúa como <strong>intermediario tecnológico y operativo</strong> para transferencias entre pares. No somos un banco, no captamos ahorros ni ofrecemos crédito.</p>
        <p>El servicio requiere: verificación de identidad (KYC), confirmación bancaria del pago, y disponibilidad operativa. Nos reservamos el derecho de rechazar operaciones cuando existan sospechas fundadas de fraude, LA/FT u operaciones no lícitas.</p>
      </>
    )},
    { title: 'Verificación de identidad (KYC)', body: (
      <p>Para operar debes proporcionar información y documentos válidos: cédula/RUT vigente, selfie, y en algunos casos comprobante de domicilio. La información falsa, alterada o incompleta habilita a {BRAND.name} para suspender la cuenta sin previo aviso, e informar a autoridades competentes.</p>
    )},
    { title: 'Prevención LA/FT', body: (
      <p>Como sujeto obligado conforme a la <strong>Ley 19.913 de Chile</strong>, {BRAND.name} reporta operaciones sospechosas a la Unidad de Análisis Financiero (UAF). Aplicamos controles automatizados y manuales, incluyendo revisión reforzada para operaciones de umbral elevado, PEP y jurisdicciones de alto riesgo.</p>
    )},
    { title: 'Tarifas y tasa de cambio', body: (
      <p>Nuestra comisión está incorporada en la tasa de cambio mostrada en la calculadora del sitio. Lo que ves antes de confirmar es lo que tu destinatario recibe. Podemos aplicar tasas diferenciadas por segmento, corredor o monto. La tasa mostrada es válida por un tiempo acotado (indicado en pantalla) y puede recalcularse si el pago tarda más de lo estipulado.</p>
    )},
    { title: 'Tiempos de acreditación', body: (
      <p>Trabajamos con tiempos indicativos: acreditación bancaria en 10-15 minutos hábiles, Yape/Plin (Perú) inmediatos. Los tiempos pueden variar por causas ajenas: caídas de red bancaria, fines de semana, feriados, requerimientos de compliance. Ante cualquier demora contáctanos por WhatsApp.</p>
    )},
    { title: 'Cancelación y devolución', body: (
      <p>Antes de que la transferencia sea procesada al destinatario, puedes solicitar su cancelación contactando a soporte. Una vez acreditada en la cuenta del destinatario, la operación es irreversible: los fondos son de propiedad del receptor. Si aportaste datos erróneos y el dinero llegó a la cuenta equivocada, {BRAND.name} colaborará activamente para intentar la recuperación, pero no garantiza el reembolso.</p>
    )},
    { title: 'Canal de denuncias', body: (
      <p>Si presencias o sospechas de un fraude, conducta indebida o lavado de activos puedes denunciar de forma confidencial y anónima en <button onClick={() => navigate('/denuncias')} className="underline font-semibold" style={{ color: BRAND?.theme?.primary || '#15803D' }} data-testid="terminos-denuncias-link">{BRAND.domain}/denuncias</button>. Garantizamos no represalias contra denunciantes de buena fe.</p>
    )},
    { title: 'Limitación de responsabilidad', body: (
      <p>{BRAND.name} pone su máximo esfuerzo en mantener el servicio disponible 24/7, pero no garantiza la inexistencia de interrupciones puntuales por mantenimiento, fallas de terceros (bancos, internet) o caso fortuito. No nos hacemos responsables por demoras imputables al banco de destino ni por errores en datos provistos por el usuario.</p>
    )},
    { title: 'Ley aplicable y jurisdicción', body: (
      <p>Estos términos se rigen por la legislación chilena. Cualquier controversia será conocida por los tribunales ordinarios de {cityPlaceholder}.</p>
    )},
    { title: 'Contacto', body: (
      <ul className="list-disc list-inside ml-2 space-y-1">
        <li>Email: <a href={`mailto:contacto@${BRAND.domain}`} className="underline" style={{ color: BRAND?.theme?.primary || '#15803D' }}>contacto@{BRAND.domain}</a></li>
        {wa && (
          <li>WhatsApp: <a href={`https://wa.me/${wa}`} className="underline" style={{ color: BRAND?.theme?.primary || '#15803D' }}>{waDisplay}</a></li>
        )}
      </ul>
    )},
  ];

  return (
    <LegalDocLayout
      title={`Términos y Condiciones de ${BRAND.name}`}
      updatedAt="15 de julio de 2026"
      sections={sections}
    />
  );
};

export default Terminos;
